import React from "react";
import "../styles/Banner.css";

const Banner = () => {
  return (
    <React.Fragment>
      <div className="background-container">
        <div className="banner-container">
          <h1 className="banner-online">
            Play Sweepstakes Slots & Fish Games with Orion Stars!
          </h1>
          <div className="banner-orion-star">
            Join to get a 200% bonus and start winning today!{" "}
          </div>
        </div>
        <div className="banner-container-two">
          <div className="banner-button-wrapper">
            <button className="banner-button">
              {" "}
              <a
                href="http://start.orionstars.vip:8580/index.html"
                target="_blank"
              >
                Claim Your 200% Bonus Now!
              </a>
            </button>
          </div>
        </div>
        <div className="banner-container-three">
          <div className="now-play">NOW PLAY DIRECTLY WITH US!</div>
        </div>
        {/* <div className="banner-img-bg">
          <div className="banner-img">
            <img alt="banner-img" src="../assets/banner-img.svg" />
          </div>
        </div> */}
      </div>
    </React.Fragment>
  );
};

export default Banner;
